import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKeys } from '../keys';
import { request } from '../request';
import { userQueryOptions } from './useUser';

export const useApproveAccountant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return request('/integrations/accountant/approve', { method: 'POST' });
    },
    onSuccess: () => {
      queryClient.setQueryData(userQueryOptions.queryKey, (user) => {
        if (!user) return;

        return {
          ...user,
          accountant: user.accountant ? { approved: true, data: user.accountant.data } : null,
        };
      });
      queryClient.invalidateQueries({ queryKey: QueryKeys.user });
    },
  });
};
